import {createAction} from '@reduxjs/toolkit';

export const domainMonitorsStale = createAction('monitoring/domainMonitorsStale');
export const domainIncidentsStale = createAction('monitoring/domainIncidentsStale');

type Dispatch = (_action: ReturnType<typeof domainMonitorsStale> | ReturnType<typeof domainIncidentsStale>) => unknown;

export const invalidateDomainMonitors = (dispatch: Dispatch) => dispatch(domainMonitorsStale());
export const invalidateDomainIncidents = (dispatch: Dispatch) => dispatch(domainIncidentsStale());
